import { useState } from 'react';
import toast from 'react-hot-toast';

import { useResolveTicket } from '../contexts/tickets';

import '../styles/forms.css';

// Resolver un ticket, para quien lo reportó.
//
// LA NOTA ES OBLIGATORIA y no es burocracia: el backend la exige con un mínimo
// de un carácter, y el texto del contrato es «Decí qué se le resolvió a quien
// reportó». Un ticket cerrado sin explicación deja a quien reportó con un
// estado cambiado y ninguna respuesta, que es la forma más rápida de que la
// próxima vez no reporte nada.
//
// Y SE RESUELVE DE A UNO, a propósito. Resolver el incidente que agrupa a diez
// tickets no cierra los diez: la solución puede estar desplegada en un entorno
// y no en otro, así que cada reporte se cierra cuando quedó resuelto PARA QUIEN
// LO HIZO. Eso es una decisión del tier, no una limitación de esta pantalla.

const NOTE_MAX = 5000;

export default function ResolveTicketForm({ ticket }) {
    const resolve = useResolveTicket(ticket.id);

    const [open, setOpen] = useState(false);
    const [note, setNote] = useState('');
    const [error, setError] = useState('');

    const submit = async (e) => {
        e.preventDefault();
        if (!note.trim()) {
            setError('Decí qué se le resolvió a quien reportó.');
            return;
        }

        try {
            await resolve.mutateAsync({ note: note.trim() });
            toast.success('Ticket resuelto');
            setNote('');
            setOpen(false);
        } catch (err) {
            setError(err.message || 'No se pudo resolver');
        }
    };

    if (!open) {
        return (
            <button type="button" className="ticket-form__open" onClick={() => setOpen(true)}>
                Resolver
            </button>
        );
    }

    return (
        <form className="ticket-form" onSubmit={submit}>
            <label className="ticket-form__field ticket-form__field--wide">
                <span className="ticket-form__label">Qué se le resolvió</span>
                <textarea
                    className="ticket-form__textarea"
                    value={note}
                    maxLength={NOTE_MAX}
                    rows={3}
                    placeholder="Lo que se le puede contestar a quien reportó."
                    onChange={e => { setNote(e.target.value); setError(''); }}
                    autoFocus
                />
            </label>

            {error && <p className="ticket-form__error">{error}</p>}

            <div className="ticket-form__actions">
                <button type="submit" className="ticket-form__submit" disabled={resolve.isPending}>
                    {resolve.isPending ? 'Guardando…' : 'Resolver'}
                </button>
                <button
                    type="button"
                    className="ticket-form__cancel"
                    onClick={() => { setOpen(false); setError(''); }}
                >
                    Cancelar
                </button>
            </div>
        </form>
    );
}
